import { ContentType } from '@entries/content-types'
import ContentfulContentArticleAccordion from '@entries/contentful-content-article-accordion'
import ContentfulWrapperInbentaContentList from '@entries/contentful-faq-page-list'
import ContentfulReview from '@entries/contentful-review'
import ContentfulWrapperRichMedia from '@entries/contentful-wrapper-rich-media'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { AccordionList } from '@ui/accordion-list'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulPageSectionAccordion: Utils.EntryFC<
  Queries.ContentfulPageSectionAccordionFragment
> = ({ content: { contents } }) => (
  <AccordionList>
    {contents?.map((item: any, i: number) => (
      <Entry
        key={`accordion-item-${item.id}-${i}`}
        content={item}
        mapping={{
          [ContentType.ContentfulContentArticle]:
            ContentfulContentArticleAccordion,
          [ContentType.ContentfulWrapperRichMedia]: ContentfulWrapperRichMedia,
          [ContentType.ContentfulReview]: ContentfulReview,
          [ContentType.ContentfulFaqPageList]:
            ContentfulWrapperInbentaContentList,
        }}
      />
    ))}
  </AccordionList>
)

export const query = graphql`
  fragment ContentfulPageSectionAccordion on ContentfulSection {
    ...ContentfulEntry
    contents {
      ...ContentArticleAccordion
      ...ContentfulWrapperRichMedia
      ...ContentfulReview
      ...ContentfulFaqPageList
    }
  }
`
export default withDisplayName(
  ContentfulPageSectionAccordion,
  'ContentfulPageSectionAccordion'
)
